import React, { useState } from 'react';
import '../styles/AutofillAIForm.css';
import { validateURL } from "../components/RegExs";

const AutofillAIForm = ({ onSubmitSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    Website: ""
  });

  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //Updates form infromation when information changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    //console.log("Updated formData:", formData); //this was annoying me
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setErrorMessage(null);
    console.log("handleSubmit triggered.");
    console.log("Form data before submission:", formData);
    
    //Checks for URL
    if (!formData.Website) {
      console.error("Resource URL is empty. Cannot proceed.");
      setErrorMessage("Please provide a valid URL.");
      return;
    }

    if (!validateURL(formData.Website)) {
      console.error("Resource URL is not in proper format.");
      setErrorMessage("Please provide a valid https URL.");
      return;
    }
  
    setIsLoading(true);
   // Calls AI_Analuze API call to get resource information
    try {
      console.log("Sending POST request to AI API...");
  
      const requestBody = JSON.stringify({ website: formData.Website });
      console.log("Request body:", requestBody);
  
      const response = await fetch("https://mycommunityfl.com/resource/AI_Analyze", {
        method: "POST",
        body: requestBody,
        headers: { 'Content-Type': 'application/json' }
      });
  
      console.log("Response received:", response);
      
      // Checks for valid response
      if (!response.ok) {
        console.error("Failed to connect to AI model. Status:", response.status);
        setErrorMessage(`Error: Unable to fetch data (status ${response.status}).`);
        setIsLoading(false);
        return;
      }
  
      const result = await response.json();
      console.log('AI analysis complete, result:', result);
      
      // Checks for valid result
      if (result.error) {
        console.error("Error from AI:", result.message);
        setErrorMessage(result.message);
      } else {
        console.log("Passing result to onSubmitSuccess...");
        onSubmitSuccess(result);
        setErrorMessage(null);
      }
    } catch (error) {
      console.error('Error occurred while getting AI analysis:', error);
      setErrorMessage('An error occurred while processing your request.');
    } finally {
      setIsLoading(false);
    }
  };
  
  // Auto Fill Format
  return (
    <div className="AutofillAIForm">
      <h3>Autofill Resource Form with AI</h3>
      <p id="ai-source">powered by OpenAI*</p>
      <p id="plain-warning">IT IS YOUR RESPONSIBILITY TO VERIFY THE AI RESPONCE FOR ACCURACY</p>
      <div className="AIRequest">
        <label>
          Resource Center URL:
          <input
            type="text"
            name="Website"
            value={formData.Website}
            onChange={handleChange}
            placeholder="Enter a URL for a Florida Resoruce Center."
          />
        </label>
        {errorMessage && <div className="error-message">{errorMessage}</div>} {/* Display error message */}
        <div className="buttons">
          <button type="submit" id="blue" onClick={handleSubmit}>Search</button>

          {isLoading && <p id="loading-msg">loading...</p>} {/*conditionally show loading message when search is started*/}

          <button type="button" id="red" onClick={onCancel}>Cancel</button>
        </div>
        <p id="disclaimer">
          *Information provided by this tool may not always be accurate.
          It is your responsibility to review and verify the accuracy of the information before using it.
          The creators of this tool are not liable for any errors or ommissions.</p>
      </div>
    </div>
  );
};

export default AutofillAIForm;
